<div class="main_header_div">
  <div class="header_name">
    View Image
  </div>
  <div class="close-icon">
    <img src="assets/icons/dashboard-icons/close-pink-icon.svg" (click)="closeDialog()">
  </div>
</div>
<div class="main_content_div">
  <div class="d-flex justify-content-start mb-3 mt-3">
    <button class="btn btn-primary" (click)="downloadAllImages()">Download Images</button>
  </div>
  <div *ngIf="documentViewUrls.length > 0; else noImages">
    <div *ngFor="let url of documentViewUrls">
      <img [src]="url" style="max-width: 100%; margin-bottom: 12px;" />
    </div>
  </div>

      
  <ng-template #noImages>
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1vh; height: 100%; width: 100%;">
      <img class="no-img" src="assets/images/no-goal.png" alt="No images" />
      <p>No images available</p>
    </div>
  </ng-template>        
</div>
